import { render, staticRenderFns } from "./ReportSearchBlock.vue?vue&type=template&id=56f68972"
import script from "./ReportSearchBlock.vue?vue&type=script&lang=js"
export * from "./ReportSearchBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports